import { render, staticRenderFns } from "./AllOrg.vue?vue&type=template&id=8804354e&scoped=true&"
import script from "./AllOrg.vue?vue&type=script&lang=js&"
export * from "./AllOrg.vue?vue&type=script&lang=js&"
import style0 from "./AllOrg.vue?vue&type=style&index=0&id=8804354e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8804354e",
  null
  
)

export default component.exports